<template>
  <v-main v-if="loading || error">
    <app-loading :visible="loading"></app-loading>
    <div v-if="error" class="text-center ma-5">
      Não foi possivel carregar o comprovante
    </div>
  </v-main>
  <div v-else class="document">
    <document-header :account="sender.name" description="Comprovante<br>de Transferência"></document-header>
    <div class="container">
      <div class="row row-wrap">
        <div class="col-6">
          <div class="item-box">
            <div class="item-box-header"><h4>Conta debitada</h4></div>
            <div class="item-box-content">
              <div class="row">
                <!-- <div class="col">
                  <h5>CPF/CNPJ</h5>
                  {{ sender.document | document }}
                </div> -->
                <div class="col">
                  <h5>Conta Heppi</h5>
                  {{ sender.heppiAccount }}
                </div>
              </div>
              <h5>Nome</h5>
              {{ sender.name }}
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="item-box">
            <div class="item-box-header"><h4>Favorecido</h4></div>
            <div class="item-box-content">
              <div class="row">
                <!-- <div class="col">
                  <h5>CPF/CNPJ</h5>
                  {{ receiver.document | document }}
                </div> -->
                <div class="col">
                  <h5>Conta Heppi</h5>
                  {{ receiver.heppiAccount }}
                </div>
              </div>
              <h5>Nome</h5>
              {{ receiver.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="item-box mt-4">
        <div class="item-box-header"><h3>Detalhes da Transferência</h3></div>
        <div class="item-box-content">
          <div class="row">
            <div class="col-auto pa-5">
              <div class="amount">
                {{ amount | priceInteger }}<small>,{{ amount | priceCents }}</small>
              </div>
            </div>
            <div class="col-auto pa-5 text-uppercase">
              <h5>Realizado em</h5>
              <div class="text-bold">
                {{ date | moment('DD MMM YYYY') }}
              </div>
            </div>
            <div class="col pa-5">
              <h5>Finalidade</h5>
              {{ description }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import AppLoading from '@/components/Loading'
import documentHeader from '@/components/documentHeader'
import { mapGetters } from 'vuex'

export default {
  name: 'transfer',
  components: {
    AppLoading,
    documentHeader
  },
  data () {
    return {
      loading: false,
      error: false,
      sender: {
        name: '',
        heppiAccount: '',
        document: ''
      },
      receiver: {
        name: '',
        heppiAccount: '',
        document: ''
      },
      amount: 0,
      date: '2022-09-26',
      description: ''
    }
  },
  computed: {
    ...mapGetters(['transactionById']),
    transactionId () {
      return (this.$route.query && this.$route.query.id) || null
    },
    transactionData () {
      return this.transactionId ? this.transactionById(this.transactionId) : null
    },
    queryAccountId () {
      return (this.$route.query && this.$route.query.accountId) || null
    },
    queryCategory () {
      return (this.$route.query && this.$route.query.category) || null
    }
  },
  async created () {
    let transaction = this.transactionData

    // If transaction not in Vuex store (e.g. opened in new tab), fetch from API using query params
    if (!transaction && this.transactionId && this.queryAccountId) {
      this.loading = true
      try {
        const body = { accountId: this.queryAccountId }
        if (this.queryCategory) {
          body.category = this.queryCategory
        }
        const response = await fetch('https://n8n.heppi.io/webhook/mongodb-payments', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(body)
        })
        if (response.ok) {
          const data = await response.json()
          console.log('[Transfer] Raw response:', data)
          let transfers = Array.isArray(data) ? data : [data]
          if (transfers.length > 0 && transfers[0].json) {
            transfers = transfers.map(e => e.json)
          }
          console.log('[Transfer] Transfers parsed:', transfers.length, 'items')
          console.log('[Transfer] Looking for ID:', this.transactionId)
          if (transfers.length > 0) {
            console.log('[Transfer] First item _id:', JSON.stringify(transfers[0]._id))
          }
          transaction = transfers.find(e => {
            const id = e._id && e._id.$oid ? e._id.$oid : e._id
            return id === this.transactionId
          }) || null
          console.log('[Transfer] Transaction found:', !!transaction)
        } else {
          console.error('[Transfer] Webhook response not ok:', response.status)
        }
        if (!transaction) {
          this.error = true
          this.loading = false
          return
        }
      } catch (error) {
        console.error('[Transfer] Erro ao buscar transação:', error)
        this.error = true
        this.loading = false
        return
      }
    }

    if (transaction) {
      this.loading = true
      // sender
      const senderId = transaction.sender ? transaction.sender.id : (transaction.account_id || this.queryAccountId)
      try {
        const sender = await axios.get('accounts/' + senderId + '?api_key=' + senderId, { baseURL: 'https://payment-gateway-api.heppi.io/api/' })
        if (sender.data) {
          this.sender = {
            name: sender.data.name.indexOf('(') > 0 ? sender.data.name.substring(0, sender.data.name.indexOf('(')) : sender.data.name,
            heppiAccount: sender.data.account_number,
            document: sender.data.owner ? sender.data.owner.document : ''
          }
        }
      } catch (error) {
        // Fallback to transaction embedded data (e.g. external account like Mercado Pago)
        if (transaction.sender) {
          this.sender = {
            name: transaction.sender.name || '',
            heppiAccount: transaction.sender.account_number || '',
            document: ''
          }
        }
      }
      // receiver
      const receiverId = transaction.receiver ? transaction.receiver.id : (transaction.account_id || this.queryAccountId)
      try {
        const receiver = await axios.get('accounts/' + receiverId + '?api_key=' + receiverId, { baseURL: 'https://payment-gateway-api.heppi.io/api/' })
        if (receiver.data) {
          this.receiver = {
            name: receiver.data.name.indexOf('(') > 0 ? receiver.data.name.substring(0, receiver.data.name.indexOf('(')) : receiver.data.name,
            heppiAccount: receiver.data.account_number,
            document: receiver.data.owner ? receiver.data.owner.document : ''
          }
        }
      } catch (error) {
        // Fallback to transaction embedded data (e.g. external account like Mercado Pago)
        if (transaction.receiver) {
          this.receiver = {
            name: transaction.receiver.name || '',
            heppiAccount: transaction.receiver.account_number || '',
            document: ''
          }
        }
      }
      this.amount = transaction.amount
      const paymentDate = transaction.payment_date && transaction.payment_date.$date ? transaction.payment_date.$date : transaction.payment_date
      this.date = this.$moment(paymentDate, 'YYYY-MM-DD[T]HH:mm[.000Z]').subtract(3, 'hours').format('YYYY-MM-DD HH:mm')
      this.description = transaction.description
      this.loading = false
    }
    document.title = this.sender.name + ' - ' + this.receiver.name + ' - transferencia - ' + this.$moment(this.date).format('DD-MM-YYYY')
  }
}
</script>
